import React from 'react';
import AlphaArrowButtons from './ArrowButtons.alpha';
import LegacyArrowButtons from './ArrowButtons.legacy';

interface ArrowButtonsProps {
  goToNext: () => void;
  goToPrev: () => void;
}

const Component = process.env.IS_LEGACY ? LegacyArrowButtons : AlphaArrowButtons;
export default Component as React.FC<ArrowButtonsProps>;
